export default {
  en: {
    'pages.manage-users.title': 'Users',
    'pages.manage-users.invite': 'Invite user',
    'pages.manage-users.unauthorized':
      'You do not have permissions to view this page. Please contact your administrator',
    'pages.manage-users.registration-access': 'Access to registrations',
    'pages.manage-users.disallowed': "Can't change own permissions",
    'pages.manage-users.management': 'Select Management Group',
  },
};
